import { FC, PropsWithChildren } from 'react';
import { HorizontalPaddingLayout } from '@/layouts/HorizontalPadding';
import { Divider } from '@/components/Divider';

export const FundCompositionPieChartLayout: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  return (
    <>
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        {children}
      </HorizontalPaddingLayout>
    </>
  );
};
